import { PrismaClient } from '@prisma/client';

let client: PrismaClient | undefined;

export function getDb(): PrismaClient {
  client ??= new PrismaClient();
  return client;
}

export async function checkDatabase(): Promise<boolean> {
  try {
    await getDb().$queryRaw`SELECT 1`;
    return true;
  } catch {
    return false;
  }
}

export async function closeDb(): Promise<void> {
  await client?.$disconnect();
  client = undefined;
}
